//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    children: {
      type: Array,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },
  methods: {
    generateURL(childSlug) {
      const updatedCollectionSlug = this.slug.replace('_', '-');
      return `/collections/${updatedCollectionSlug}/${childSlug}/`;
    },
  },
};
